<div class="home-protection-location-modal">
	<h1>{{ header | translate }} </h1>
	<div role="button" class="close-btn" (click)="onCancelClick($event)">
		<img [src]=" 'assets/icons/Close.svg' | svgInline | async" alt="" srcset="">
	</div>
	<p class="description">
		{{ description | translate }}
	</p>
	<ul>
		<li *ngFor="let package of packages">{{ package }}</li>
	</ul>
	<div class="d-flex">
		<div class="ml-0 mr-4 pl-0">
			<button type="button"
				class="btn btn-default modal-button"
				(click)="onOkClick($event)">
				{{OkText | translate}}
			</button>
		</div>
		<div class="ml-0 mr-4 pl-0">
			<div role="button"
				class="btn btn-default modal-button-cancel"
				(click)="onCancelClick($event)">
				{{CancelText | translate}}
			</div>
		</div>
	</div>
</div>
